import { Box2d } from '@tldraw/tldraw'
import { Position } from 'components/VisualStudioPlayground/Tools/SelectTool/childStates/Measuring'
import { MeasurementLine } from './MeasurementLine'

interface Props {
  selectedBounds: Box2d
  hoveredBounds: Box2d
  position: Position
}

export const MeasurementLines = ({ selectedBounds, hoveredBounds, position }: Props) => {
  const selectedLeft = selectedBounds.x
  const selectedRight = selectedLeft + selectedBounds.w
  const selectedTop = selectedBounds.y
  const selectedBottom = selectedTop + selectedBounds.h
  const hoveredLeft = hoveredBounds.x
  const hoveredRight = hoveredLeft + hoveredBounds.w
  const hoveredTop = hoveredBounds.y
  const hoveredBottom = hoveredTop + hoveredBounds.h

  // Special cases for inside/outside overlapping shapes
  const insideVerticalLineX =
    (Math.max(selectedBounds.x, hoveredBounds.x) +
      Math.min(selectedBounds.x + selectedBounds.width, hoveredBounds.x + hoveredBounds.width)) /
    2
  const insideHorizontalLineY =
    (Math.max(selectedBounds.y, hoveredBounds.y) +
      Math.min(selectedBounds.y + selectedBounds.height, hoveredBounds.y + hoveredBounds.height)) /
    2

  return (
    <svg className="tl-overlays__item">
      {position === 'top' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedTop}
            crossAxisEnd={hoveredBottom}
            orientation="vertical"
          />
          {selectedBounds.center.x < hoveredLeft && (
            <MeasurementLine
              dotted
              mainAxis={hoveredBottom}
              crossAxisStart={selectedBounds.center.x}
              crossAxisEnd={hoveredLeft}
              orientation="horizontal"
            />
          )}
          {selectedLeft > hoveredLeft && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredLeft}
                crossAxisStart={selectedBottom}
                crossAxisEnd={hoveredBottom}
                orientation="vertical"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.y}
                crossAxisStart={selectedLeft}
                crossAxisEnd={hoveredLeft}
                orientation="horizontal"
              />
            </>
          )}
          {selectedBounds.center.x > hoveredRight && (
            <MeasurementLine
              dotted
              mainAxis={hoveredBottom}
              crossAxisStart={selectedBounds.center.x}
              crossAxisEnd={hoveredRight}
              orientation="horizontal"
            />
          )}
          {selectedRight < hoveredRight && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredRight}
                crossAxisStart={selectedBottom}
                crossAxisEnd={hoveredBottom}
                orientation="vertical"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.y}
                crossAxisStart={selectedRight}
                crossAxisEnd={hoveredRight}
                orientation="horizontal"
              />
            </>
          )}
        </>
      )}
      {position === 'bottom' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedBottom}
            crossAxisEnd={hoveredTop}
            orientation="vertical"
          />
          {selectedBounds.center.x < hoveredLeft && (
            <MeasurementLine
              dotted
              mainAxis={hoveredTop}
              crossAxisStart={selectedBounds.center.x}
              crossAxisEnd={hoveredLeft}
              orientation="horizontal"
            />
          )}
          {selectedLeft > hoveredLeft && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredLeft}
                crossAxisStart={selectedTop}
                crossAxisEnd={hoveredTop}
                orientation="vertical"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.y}
                crossAxisStart={selectedLeft}
                crossAxisEnd={hoveredLeft}
                orientation="horizontal"
              />
            </>
          )}
          {selectedBounds.center.x > hoveredRight && (
            <MeasurementLine
              dotted
              mainAxis={hoveredTop}
              crossAxisStart={selectedBounds.center.x}
              crossAxisEnd={hoveredRight}
              orientation="horizontal"
            />
          )}
          {selectedRight < hoveredRight && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredRight}
                crossAxisStart={selectedTop}
                crossAxisEnd={hoveredTop}
                orientation="vertical"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.y}
                crossAxisStart={selectedRight}
                crossAxisEnd={hoveredRight}
                orientation="horizontal"
              />
            </>
          )}
        </>
      )}
      {position === 'left' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedLeft}
            crossAxisEnd={hoveredRight}
            orientation="horizontal"
          />
          {selectedBounds.center.y < hoveredTop && (
            <MeasurementLine
              dotted
              mainAxis={hoveredRight}
              crossAxisStart={selectedBounds.center.y}
              crossAxisEnd={hoveredTop}
              orientation="vertical"
            />
          )}
          {selectedTop > hoveredTop && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredTop}
                crossAxisStart={selectedBounds.center.x}
                crossAxisEnd={hoveredLeft}
                orientation="horizontal"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.x}
                crossAxisStart={selectedTop}
                crossAxisEnd={hoveredTop}
                orientation="vertical"
              />
            </>
          )}
          {selectedBounds.center.y > hoveredBottom && (
            <MeasurementLine
              dotted
              mainAxis={hoveredRight}
              crossAxisStart={selectedBounds.center.y}
              crossAxisEnd={hoveredBottom}
              orientation="vertical"
            />
          )}
          {selectedBottom < hoveredBottom && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredBottom}
                crossAxisStart={selectedBounds.center.x}
                crossAxisEnd={hoveredLeft}
                orientation="horizontal"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.x}
                crossAxisStart={selectedBottom}
                crossAxisEnd={hoveredBottom}
                orientation="vertical"
              />
            </>
          )}
        </>
      )}
      {position === 'right' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedRight}
            crossAxisEnd={hoveredLeft}
            orientation="horizontal"
          />
          {selectedBounds.center.y < hoveredTop && (
            <MeasurementLine
              dotted
              mainAxis={hoveredLeft}
              crossAxisStart={selectedBounds.center.y}
              crossAxisEnd={hoveredTop}
              orientation="vertical"
            />
          )}
          {selectedTop > hoveredTop && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredTop}
                crossAxisStart={selectedBounds.center.x}
                crossAxisEnd={hoveredRight}
                orientation="horizontal"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.x}
                crossAxisStart={selectedTop}
                crossAxisEnd={hoveredTop}
                orientation="vertical"
              />
            </>
          )}
          {selectedBounds.center.y > hoveredBottom && (
            <MeasurementLine
              dotted
              mainAxis={hoveredLeft}
              crossAxisStart={selectedBounds.center.y}
              crossAxisEnd={hoveredBottom}
              orientation="vertical"
            />
          )}
          {selectedBottom < hoveredBottom && (
            <>
              <MeasurementLine
                dotted
                mainAxis={hoveredBottom}
                crossAxisStart={selectedBounds.center.x}
                crossAxisEnd={hoveredRight}
                orientation="horizontal"
              />
              <MeasurementLine
                mainAxis={selectedBounds.center.x}
                crossAxisStart={selectedBottom}
                crossAxisEnd={hoveredBottom}
                orientation="vertical"
              />
            </>
          )}
        </>
      )}
      {position === 'top-left' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedLeft}
            crossAxisEnd={hoveredRight}
            orientation="horizontal"
          />
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedTop}
            crossAxisEnd={hoveredBottom}
            orientation="vertical"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredBottom}
            crossAxisStart={selectedBounds.center.x}
            crossAxisEnd={hoveredRight}
            orientation="horizontal"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredRight}
            crossAxisStart={selectedBounds.center.y}
            crossAxisEnd={hoveredBottom}
            orientation="vertical"
          />
        </>
      )}
      {position === 'top-right' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedRight}
            crossAxisEnd={hoveredLeft}
            orientation="horizontal"
          />
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedTop}
            crossAxisEnd={hoveredBottom}
            orientation="vertical"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredBottom}
            crossAxisStart={hoveredLeft}
            crossAxisEnd={selectedBounds.center.x}
            orientation="horizontal"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredLeft}
            crossAxisStart={selectedBounds.center.y}
            crossAxisEnd={hoveredBottom}
            orientation="vertical"
          />
        </>
      )}
      {position === 'bottom-left' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedLeft}
            crossAxisEnd={hoveredRight}
            orientation="horizontal"
          />
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedBottom}
            crossAxisEnd={hoveredTop}
            orientation="vertical"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredTop}
            crossAxisStart={selectedBounds.center.x}
            crossAxisEnd={hoveredRight}
            orientation="horizontal"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredRight}
            crossAxisStart={selectedBounds.center.y}
            crossAxisEnd={hoveredTop}
            orientation="vertical"
          />
        </>
      )}
      {position === 'bottom-right' && (
        <>
          <MeasurementLine
            mainAxis={selectedBounds.center.y}
            crossAxisStart={selectedRight}
            crossAxisEnd={hoveredLeft}
            orientation="horizontal"
          />
          <MeasurementLine
            mainAxis={selectedBounds.center.x}
            crossAxisStart={selectedBottom}
            crossAxisEnd={hoveredTop}
            orientation="vertical"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredTop}
            crossAxisStart={selectedBounds.center.x}
            crossAxisEnd={hoveredLeft}
            orientation="horizontal"
          />
          <MeasurementLine
            dotted
            mainAxis={hoveredLeft}
            crossAxisStart={selectedBounds.center.y}
            crossAxisEnd={hoveredTop}
            orientation="vertical"
          />
        </>
      )}
      {position === 'inside' && (
        <>
          <MeasurementLine
            mainAxis={insideVerticalLineX}
            crossAxisStart={hoveredTop}
            crossAxisEnd={selectedTop}
            orientation="vertical"
          />
          <MeasurementLine
            mainAxis={insideVerticalLineX}
            crossAxisStart={hoveredBottom}
            crossAxisEnd={selectedBottom}
            orientation="vertical"
          />
          <MeasurementLine
            mainAxis={insideHorizontalLineY}
            crossAxisStart={hoveredLeft}
            crossAxisEnd={selectedLeft}
            orientation="horizontal"
          />
          <MeasurementLine
            mainAxis={insideHorizontalLineY}
            crossAxisStart={hoveredRight}
            crossAxisEnd={selectedRight}
            orientation="horizontal"
          />
        </>
      )}
    </svg>
  )
}
